import { Outlet } from '@tanstack/react-router';
import SystemOutage from '@zeus/core/SystemOutage';
import { useSystemAlert } from '_/contexts/SystemAlertContext';
import React, { ReactElement } from 'react';

import MainLayout from './common/layout/MainLayout';

interface SystemAlertType {
  outage?: boolean;
  type?: string;
  message?: string;
  title?: string;
}

function MainContent(): ReactElement {
  const { systemAlert } = useSystemAlert();
  const { outage, message, title } = systemAlert as SystemAlertType;

  if (outage) {
    return <SystemOutage message={message} title={title} />;
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

export default MainContent;
